module.exports = __webpack_public_path__ + "static/assets/384eb8349ef92e895f1feb65aa60602a.png";